import type { Kitchen } from '@rta/rta-blueprint-library';

import { getDimensionMeasurement } from '@r-core/helpers';

export type CornerTrimNoteLine = {
	label: string;
	value: string;
};

// same height convention the designer flat-trim view names its pieces by (get-flat-trim-name.ts)
const CORNER_TRIM_HEIGHT_NAMES: Record<string, string> = {
	'34.5': 'Grill Height',
	'37': 'Pizza/Corner Height',
	'39.25': 'Bar Height'
};

/** Counts the L-profile corner trims still on the design, grouped and named by height, shortest first */
export const getCornerTrimNoteLines = (kitchen: Kitchen): Array<CornerTrimNoteLine> => {
	const counts: Map<string, number> = new Map();

	kitchen.design.islands.children.forEach((island) => {
		(island.panelTrims?.children ?? []).forEach((panelTrim) => {
			if (panelTrim.isFlat) return;

			// nearHeight is this trim's own island height -- an L-profile never spans a seam
			const measurement = getDimensionMeasurement(panelTrim.flatTrimDimensions.nearHeight, false);
			counts.set(measurement, (counts.get(measurement) ?? 0) + 1);
		});
	});

	return Array.from(counts.entries())
		.sort(([firstMeasurement], [secondMeasurement]) => Number(firstMeasurement) - Number(secondMeasurement))
		.map(([measurement, count]) => ({
			label: `Standard ${CORNER_TRIM_HEIGHT_NAMES[measurement] ?? `${measurement}"`} Corner Trim:`,
			value: `Qty - ${count}`
		}));
};
